export default __webpack_public_path__ + "static/activite-a2229df9812f25324b82dee5a0e9023a.png";